import React, { useState } from 'react';

import { Menu, Modal, SaveButton, useModalConfirm } from 'components';
import ProductThumbnailImage from 'components/layout/ProductThumbnailImage';
import { notifyApiError, notifyCommon } from 'components/layout/Toasts';

import { VariationsApi } from 'src/api';

import MoveGroupProductForm from '../MoveGroupProductForm';

import styles from './VariationsGroupProductThumbnail.module.scss';

const VariationsGroupProductThumbnail = ({
  id,
  thumbnail,
  image,
  name,
  unit_name,
  collection_amount,
  producer,
  category,
  groupId,
  refreshCallback
}) => {
  const [isMoveProductOpen, setIsMoveProductOpen] = useState(false);

  const [renderedModalConfirm, handleOpenModalConfirm] = useModalConfirm();

  const handleRemoveProduct = async () => {
    try {
      const { data } = await VariationsApi.removeGroupProduct(id);
      if (refreshCallback) refreshCallback(true);
      notifyCommon([data.message]);
    } catch (err) {
      notifyApiError(err);
    }
  };

  const openRemoveProductModalConfirm = () => {
    handleOpenModalConfirm({
      message: 'Na pewno chcesz usunąć wybrany produkt z grupy?',
      handleConfirm: handleRemoveProduct,
      content: (
        <p>
          Usunięty zostanie produkt o nazwie <strong>{name}</strong>.
        </p>
      )
    });
  };

  const actions = [
    {
      title: 'Przenieś do innej grupy',
      icon: 'move',
      action: () => setIsMoveProductOpen(true)
    }
  ];

  return (
    <>
      <div className={styles.container}>
        <div className={styles.nameWrapper}>
          <ProductThumbnailImage
            thumbnail={thumbnail}
            image={image}
            title={name}
            id={id}
            size={'tiny'}
          />
          <p>{name}</p>
        </div>
        <div>{unit_name}</div>
        <div>{collection_amount}</div>
        <div>{producer}</div>
        <div>{category}</div>
        <div className={styles.actions}>
          <SaveButton
            type={'delete'}
            onClick={openRemoveProductModalConfirm}
          />
          <Menu
            className={styles.menu}
            actions={actions}
          />
        </div>
      </div>
      <Modal
        visible={isMoveProductOpen}
        onClose={() => setIsMoveProductOpen(false)}
        title={'Przenieś produkt'}
      >
        <MoveGroupProductForm
          productName={name}
          productId={id}
          groupId={groupId}
          closeModal={() => setIsMoveProductOpen(false)}
          refreshCallback={refreshCallback}
        />
      </Modal>
      {renderedModalConfirm}
    </>
  );
};

export default VariationsGroupProductThumbnail;
